/**
 * Component for displaying resource violations in a formatted list
 */

import React from 'react';

interface ResourceViolationsListProps {
  violations: Record<string, unknown>;
}

export const ResourceViolationsList: React.FC<ResourceViolationsListProps> = ({ violations }) => {
  const toDisplay = (val: unknown): string => {
    if (val == null) return '—';
    if (typeof val === 'string') return val;
    if (typeof val === 'number' || typeof val === 'boolean') return String(val);
    return JSON.stringify(val);
  };

  return (
    <ul className="ml-4 list-disc space-y-1">
      {Object.entries(violations).map(([ruleset, guards]) =>
        Array.isArray(guards) && guards.length > 0 ? (
          <li key={ruleset} className="text-xs">
            <span className="font-semibold text-gray-900 dark:text-gray-100">{toDisplay(ruleset)}:</span>{' '}
            <span className="text-gray-700 dark:text-gray-300">
              {guards.map((g, i) => (
                <span key={String(g)}>
                  {toDisplay(g)}
                  {i < guards.length - 1 ? ', ' : ''}
                </span>
              ))}
            </span>
          </li>
        ) : (
          <li key={ruleset} className="text-xs">
            <span className="font-semibold text-gray-900 dark:text-gray-100">{toDisplay(ruleset)}</span>
          </li>
        )
      )}
    </ul>
  );
};
